// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './element_ui' // element
import './styles/basic.scss' // 基础样式
import './components/register' // 全局注册组件
import '../static/iconfont/iconfont.css'
import './styles/animate/hover.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js